/**
 * Prise en main de l'exercice « sur la feuille » : un calque plein écran qui
 * met en lumière, dans la page, les touches de réponse, « Check », « Écrire au
 * brouillon » et la ligne en cours. Une fois par appareil ; relancée par « ? ».
 */

import './scratch-sheet.css';
import { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { SheetTutorial, markPaperTutorialSeen, paperTutorialSteps } from './sheet-tutorial';

export function PaperTutorial({ free, onDone }: { free: boolean; onDone: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  // seulement les zones présentes (pas de brouillon → pas d'étape « brouillon »)
  const [steps] = useState(() =>
    paperTutorialSteps(free).filter((s) => !!document.querySelector(`[data-tuto="${s.target}"]`)),
  );
  useEffect(() => {
    markPaperTutorialSeen();
  }, []);
  useEffect(() => {
    if (steps.length === 0) onDone();
  }, [steps, onDone]);
  if (steps.length === 0) return null;
  return createPortal(
    <div ref={ref} className="sc-root fixed inset-0 z-[75]" data-testid="paper-tutorial">
      <SheetTutorial container={ref} free={free} steps={steps} inDocument onDone={onDone} />
    </div>,
    document.body,
  );
}
